var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLineMeasure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.1958,
    width: 13,
    height: 5,
    rx: 0.9,
    stroke: "#0C002C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3.65186,
    x2: 3,
    y2: 5.65186,
    stroke: "#0C002C",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 3.65186,
    x2: 5,
    y2: 5.65186,
    stroke: "#0C002C",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3.65186,
    x2: 7,
    y2: 5.65186,
    stroke: "#0C002C",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 3.65186,
    x2: 9,
    y2: 5.65186,
    stroke: "#0C002C",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 3.65186,
    x2: 11,
    y2: 5.65186,
    stroke: "#0C002C",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1.04879,
    y1: 7.80179,
    x2: 1.02889,
    y2: 12.8062,
    stroke: "#0C002C",
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 13.0722,
    y1: 7.80179,
    x2: 13.0523,
    y2: 12.8062,
    stroke: "#0C002C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLineMeasure);
export default __webpack_public_path__ + "static/media/ico_line_measure.e83fe4d5d770901f168fbb92a082a0a4.svg";
export { ForwardRef as ReactComponent };